import PropTypes from 'prop-types';
import { useState } from 'react';

import Styles from './styles';
import { formatTotal, inPercent } from './utils';
import { connectLocation } from '../../location/LocationConnectors';
import { RatingStarLine } from '../RatingStarLine';
import { RatingTable } from '../RatingTable';
import { ReviewModal } from '../ReviewModal';

// Calculate total reviews
const totalReviews = starRating => Object.keys(starRating).reduce((acc, key) => acc + starRating[key], 0);

const RatingBase = ({
  ratingAverageValue = 0,
  starRating = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
  },
  t,
}) => {
  const [reviewModalVisible, setReviewModalVisible] = useState(false);
  const reviewModalShow = isOpen => () => setReviewModalVisible(isOpen);

  return (
    <div css={Styles}>
      <div className="rating-layout">
        <h3 className="rating-title">{t('bazaarvoice.overall_rating')}</h3>

        <div className="rating-section">
          <div className="rating-section_data">
            <div className="rating-values">
              <div className="rating-average-value">{ratingAverageValue}</div>
              <div>
                <RatingStarLine percent={inPercent(ratingAverageValue)} />
              </div>
            </div>

            <RatingTable starRating={starRating} totalReviews={totalReviews(starRating)} />

            <div className="rating-average-description">
              {t('bazaarvoice.average_rating', { total: formatTotal(totalReviews(starRating)) })}
            </div>
          </div>

          <div className="rating-section_delimiter" />

          <div className="rating-share">
            <p className="rating-share-description">{t('bazaarvoice.share_opinion')}</p>

            <div>
              <button
                type="button"
                className="rating-button"
                onClick={reviewModalShow(true)}
                data-track="open-modal"
                data-track-modal-name="write a review"
              >
                {t('bazaarvoice.write_a_review')}
              </button>
              {reviewModalVisible && <ReviewModal onClose={reviewModalShow(false)} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RatingBase.propTypes = {
  ratingAverageValue: PropTypes.number.isRequired,
  starRating: PropTypes.shape({
    1: PropTypes.number,
    2: PropTypes.number,
    3: PropTypes.number,
    4: PropTypes.number,
    5: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export const Rating = connectLocation(RatingBase);
